<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded" style="overflow-x: scroll;">
            <div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.manage_flow)}}</h4>
        	</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px" v-if="loaded && service_list.length === 0">
				<container>
					<p class="text-center text-primary" style="margin: 10px 0;">{{translate(locale.no_flow)}}</p>
				</container>
        	</div>

			<template v-if="service_list.length > 0">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 table-item-container">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-5 md-small-size-5 md-medium-size-5 md-size-5">
								<div class="table-item-text">{{translate(locale.no)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{translate(locale.service)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-60 md-small-size-60 md-medium-size-60 md-size-60">
								<div class="table-item-text">{{translate(locale.unit_flow)}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-medium-size-10 md-size-10 text-right">
								<div class="table-item-text" style="justify-content: flex-end;">{{translate(locale.action)}}</div>
							</div>
						</div>
					</container>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 table-item-container" v-for="(service, index) in service_list">
					<container>
						<div class="md-layout">
							<div class="md-layout-item md-xsmall-size-5 md-small-size-5 md-medium-size-5 md-size-5">
								<div class="table-item-text">{{index+1}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-medium-size-25 md-size-25">
								<div class="table-item-text">{{service.service_name}}</div>
							</div>
							<div class="md-layout-item md-xsmall-size-60 md-small-size-60 md-medium-size-60 md-size-60">
								<div class="table-item-text">
									<template v-for="(unit, index) in service.unit_list">
										<template v-if="unit.id != null">{{unit.name}} ({{unit.level}})</template>
										<template v-else>មិនមាន</template>
										<template v-if="index < service.unit_list.length - 1">‎ ‎ ‎ ‎ → ‎ ‎ ‎ ‎</template>
									</template>
								</div>
							</div>
							<div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-medium-size-10 md-size-10 text-right">
								<router-link :to="'/flows/edit/' + service.hash"><md-button class="md-raised md-secondary"><i class="material-icons button-icon">edit</i>{{translate(locale.edit)}}</md-button></router-link>
							</div>
						</div>
					</container>
				</div>
			</template>
        </div>
    </div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", role: "" },
				loadMore: false,
				service_list: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/user/flow/list").then(data => {
					this.service_list = data.body.data;
					this.loaded = true;
				})
			}	
		}
	}
</script>
<style scoped>
	.table-item-text {
		font-weight: bold;
		color: #353690;
		display: flex;
		height: 100%;
		align-items: center;
	}
	.table-item-container {
		min-width: 1000px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Flows/View.vue